import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import './PortfolioProjectCard.css';
import { Thumbnail } from '../../../Thumbnail';

export const PortfolioProjectCard = ({ project }) => (
  <div className="col-12 col-md-6 col-lg-4 d-flex">
    <div className="card card-project w-100 align-self-stretch border-0 mb-4">
      <Thumbnail
        src={project.video_link}
        alt="video thumbnail"
        className="card-img-top w-100"
        defaultSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
        defaultVideoSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
      />
      <div className="card-body">
        <h4 className="t-21">{project.clip_name}</h4>
        <p className="t-12">{project.comments}</p>
        <h5 className="t-12 text-uppercase text-gray-light">Applied Skills</h5>
        {get(project, 'skills', []).map(skill => (
          <div className="tag t-10 text-uppercase mr-2 mb-2" key={skill}>
            {skill}
          </div>
        ))}
      </div>
      <div className="card-footer border-0 bg-transparent">
        <h5 className="t-12 text-uppercase text-gray-light">
          Contribution Level
        </h5>
        <span>
          {project.contribution_level === 'sole_contributor'
            ? 'Sole Contributor'
            : 'Partial Contributor'}
        </span>
      </div>
    </div>
  </div>
);

PortfolioProjectCard.propTypes = {
  project: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/PortfolioCard/PortfolioProjectCard/PortfolioProjectCard.js